import { ReactComponent as Logo } from '../../images/TellyLogo.svg'
import { useEffect, useRef } from 'react'
import {
  Container,
  Wrapper,
  Header,
  Title,
  LogoContainer,
  Main,
  Message,
  Text,
  RightBackground,
  Footer,
  GoToTellyApp,
} from './MobileApp.styles'
import { isMobileUserAgent } from 'constants/appStores'
import { getMobileAppURI } from 'constants/mobile'

// Matches the other redirect-only pages (MobileRegister, OpenChat, TellyPhone):
// long enough for the first paint, so the visitor sees the page rather than a
// blank frame if the app never takes over.
const DEEPLINK_DELAY_MS = 200

export const MobileApp: React.FC = (): JSX.Element => {
  const anchorRef = useRef<HTMLAnchorElement>(null)

  // Most visitors are handed here by another page (password reset, an invalid
  // link) rather than asking for it, so fire the deeplink instead of waiting
  // for a tap. Mobile only: on desktop `telly://` raises an unsupported-protocol
  // dialog, and the copy below already tells those visitors what to do.
  useEffect(() => {
    if (!isMobileUserAgent(navigator.userAgent)) {
      return
    }

    const timer = setTimeout(
      () => anchorRef.current?.click(),
      DEEPLINK_DELAY_MS
    )

    return (): void => clearTimeout(timer)
  }, [])

  return (
    <Wrapper>
      <Header>
        <LogoContainer>
          <Logo />
        </LogoContainer>
      </Header>

      <Main>
        <Container>
          <Title>almost there!</Title>
          <Message>
            Please open link on your mobile phone to finish setup.
          </Message>
          <Text>Make sure Telly mobile app is installed</Text>
          <GoToTellyApp ref={anchorRef} href={getMobileAppURI()}>
            Go to Telly Mobile App
          </GoToTellyApp>
        </Container>
        <RightBackground />
      </Main>
      <Footer />
    </Wrapper>
  )
}
